import type { FC } from "react";
import { useRecoilValue } from "recoil";

import { usePageContext } from "@ryde/redux";
import { checkIsAllInit, finalSchemaInitStateAF } from "@ryde/shared";

import { useCardFiltersFromQs, useFinalSchemaService } from "./hooks";

export const FinalSchemaService: FC = () => {
  const { entity } = usePageContext();
  const finalSchemaInitState = useRecoilValue(finalSchemaInitStateAF(entity));

  useFinalSchemaService();
  useCardFiltersFromQs({ isReady: checkIsAllInit(finalSchemaInitState) });
  return null;
};
